import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/about/login.png")